import {} from "../node/index.js";
import {} from "../port/index.js";
import {} from "./Net.js";
export function createPortFromPortEntry(node, portEntry) {
    return {
        node,
        name: portEntry.name,
        sign: portEntry.sign,
        t: portEntry.t,
        isPrincipal: portEntry.isPrincipal,
    };
}
//# sourceMappingURL=createPortFromPortEntry.js.map